"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const mobx_react_lite_1 = require("mobx-react-lite");
const styles_1 = require("./styles");
const styling_1 = require("../../../styling");
const CarouselPlayingOverlay = (0, mobx_react_lite_1.observer)(({ classes }) => {
    const mergedClasses = (0, styling_1.useStyles)({ target: classes !== null && classes !== void 0 ? classes : {}, source: styles_1.carouselPlayingOverlayStyles }, "carousel-playing-overlay");
    return react_1.default.createElement("div", { className: mergedClasses.root });
});
exports.default = CarouselPlayingOverlay;
//# sourceMappingURL=index.js.map